/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import './VerLateral.css';
import '../../Misc/Charts/GaugeGrade.css';
import Flag from 'react-flagkit';
import GaugeGrade from '../../Misc/Charts/GaugeGrade';
import GaugeGradeMobile from '../../Misc/Charts/GaugeGradeMobile';
import TwoProgressBar from './TwoProgressBar';
import { Tab, Tabs } from 'react-bootstrap';
import ProgressBarAnimated from '../../Misc/Other/ProgressBarAnimated';


function VerLateral() {
    // ---------------------------------------------------------------- PARQUE -------------------------------------------------------------------------------------------
    var nombreParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].name);
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    var aemet = (JSON.parse(sessionStorage.getItem("configuration"))[0].aemetHTML);
    var nominalPower = (JSON.parse(sessionStorage.getItem("configuration"))[0].nominalPower);
    var [Snippet, setSnippet] = useState([]);
    var [htmlSnippet, setHtmlSnippet] = useState(<></>);
    let number = 0;
    const variablesAPedir = "activePower,energyDay,nominalPower,maxEnergyDay,zones";
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/production?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataSnippet) => { setSnippet(await dataSnippet.json()); })
            .catch(e => { console.log(e); })
        setInterval(function () {
            number++;
            fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/production?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                .then(async (dataSnippet) => { setSnippet(await dataSnippet.json()); })
                .catch(e => { console.log(e); })
        }, 30000)
    }, [number]);

    var [htmlTabs, setHtmlTabs] = useState(<></>);
    useEffect(() => {
        htmlSnippet = Snippet.map((datoSnippet, index) => {
            const { activePower, energyDay, maxEnergyDay, zones } = datoSnippet;
            htmlTabs = zones.map((datoZones, index) => {
                const { nameZone, Productivity, irradiation, activePower, energyDay, maxPower, maxEnergyDay, todaysProductivity, irradiance } = datoZones;
                return (
                    <Tab key={index} eventKey={nameZone} title={nameZone}>
                        <ProgressBarAnimated title="Potencia" min={0} max={maxPower} now={activePower} percentage={activePower * 100 / maxPower} unit="kW" variant={'info'} />
                        <TwoProgressBar title1={'PR'} data1={Productivity} unit1={'%'} title2={'Irradiancia'} data2={irradiation} unit2={'W/m²'} />
                        <ProgressBarAnimated title="Energía diaria" min={0} max={maxEnergyDay} now={energyDay} percentage={energyDay * 100 / maxEnergyDay} unit="kWh" variant={'danger'} />
                        <TwoProgressBar title1={'PR día'} data1={todaysProductivity} unit1={'%'} title2={'Irradiación'} data2={irradiance} unit2={'Wh/m²'} />
                    </Tab>
                );
            })
            if (window.innerWidth < 1191 && window.innerWidth > 1022) { //Comprobamos el tamaño de la ventana
                return (
                    <div key={index}>
                        <div id='div-gauge-grade-lateral'><GaugeGradeMobile title={'Potencia actual'} title2={'Energía diaria'} min={0} max1={nominalPower} max2={maxEnergyDay} valueActiva={activePower} valueDiaria={energyDay} unit={'kW'} unit2={"kWh"} /></div>
                        <div id='div-tabs-lateral'>
                            <Tabs defaultActiveKey={zones[0].nameZone} fill>
                                {htmlTabs}
                            </Tabs>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div key={index}>
                        <div id='div-gauge-grade-lateral'><GaugeGrade title={'Potencia actual'} title2={'Energía diaria'} min={0} max1={nominalPower} max2={maxEnergyDay} valueActiva={activePower} valueDiaria={energyDay} unit={'kW'} unit2={"kWh"} /></div>
                        <div id='div-tabs-lateral'>
                            <Tabs defaultActiveKey={zones[0].nameZone} fill>
                                {htmlTabs}
                            </Tabs>
                        </div>
                    </div>
                )
            }
        });
        setHtmlSnippet(htmlSnippet);
        setHtmlTabs(htmlTabs);
    }, [Snippet]);

    return (
        <div id='div-lateral'>
            <div id='div-lateral-title-container'>
                <h2 id='farm-name-title' onClick={() => { window.location = '/#/mapa' }}>{nombreParque} <Flag country='ES' /></h2>
            </div>
            <h3 id='farm-name-title-mobile' onClick={() => { window.location = '/#/mapa' }}>{nombreParque}</h3>
            {htmlSnippet}
            <div id='div-aemet-widget'><iframe name="iframe_aemet_id33044" width="100%" height="100%" tabIndex="0" id="iframe_aemet_id33044" src={aemet}></iframe></div>
        </div>
    );
}

export default VerLateral